module.exports = __webpack_public_path__ + "media/images/front/materiales_inf-d88fb4943ea628726cf5c00c29066b2f.jpg";